import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router';
import _ from 'lodash';

import { BUSINESS_UNIT_TYPES } from '../../../utils/constants/business-unit-types';
import { RootState } from '../../../application/store';
import { keepProductsRefinements } from '../../../slices/System/systemSlice';
import { useProductsType } from './hooks/useProductsType';

import './products-type-page.scss';

import bvWtCategoryBg from '../../../assets/images/bv-watches-bg.png';
import bvJwCategoryBg from '../../../assets/images/bv-jewels-bg.png';

import BVProductsTemplate from '../../../common/templates/BVProductsTemplate/bv-products-template';
import BVEmpty from '../../../common/components/BVEmpty/bv-empty';
import BVShimmer from '../../../common/components/BVShimmers/BVShimmer/bv-shimmer';

const ProductsTypePage: React.FunctionComponent<RouteComponentProps> = (props) => {
    const {
        handleProductTypes,
        productTypes,
        productTypesLoading
    } = useProductsType();

    const history = useHistory();

    const bvCustomer = useSelector((state: RootState) => state.customer);

    useEffect(() => {
        handleProductTypes(bvCustomer.id);
    }, []);

    const _handleImageByCode = (code?: string) => (
        code === BUSINESS_UNIT_TYPES.JEWELRY_CODE ? bvJwCategoryBg : bvWtCategoryBg
    );

    const dispatch = useDispatch();

    return (
        <BVProductsTemplate {...props}>
            <div className="products-type-container">
                <BVShimmer loading={productTypesLoading} type={'shimmer-type'}>
                    <BVEmpty dataSource={productTypes || []} disclaimer={'No business units found for current customer.'}>
                        {_.map(productTypes, (dataItem, dataIndex) => (
                            <React.Fragment key={dataIndex}>
                                <div className="type-wrapper">
                                    <div
                                        className="type"
                                        onClick={() => {
                                            dispatch(keepProductsRefinements(undefined));

                                            history.push(`/catalog/${dataItem.code}`)
                                        }}
                                    >
                                        <img src={_handleImageByCode(dataItem.code)} alt={dataItem.name} />

                                        <div className="type-overlay">
                                            <span className="type-overlay-caption">
                                                {dataItem.name}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {productTypes && productTypes.length > 1 && dataIndex === 0 &&
                                    <div className="vertical-spacer"></div>
                                }
                            </React.Fragment>
                        ))}
                    </BVEmpty>
                </BVShimmer>
            </div>
        </BVProductsTemplate>
    );
}

export default ProductsTypePage;